exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-address-type[data-v-2f3f9656] {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n}", ""]);

// exports
